import markerUrl from "images/marker.png";
import iconUrl from "images/user.png";
import L, { Map as LeafletMap } from "leaflet";
import "leaflet.heat";
import "leaflet/dist/leaflet.css";
import { Controller } from "stimulus";

// L.Marker.prototype.options.icon = L.icon({
//   iconUrl,
//   iconSize: [36, 36],
//   iconAnchor: [18, 0],
// });

const defaultIcon = L.icon({
  iconUrl,
  iconSize: [36, 36],
  iconAnchor: [18, 0],
});

const specialIcon = L.icon({
  iconUrl: markerUrl,
  iconSize: [40, 40],
  iconAnchor: [20, 0],
});

interface Location {
  lat: number;
  lon: number;
  address?: string;
  marker?: boolean;
  name?: string;
  radius?: number | null;
}
export default class extends Controller {
  static values = { locations: Array, apiKey: String };
  declare map: LeafletMap;
  declare locationsValue: Location[];
  declare apiKeyValue: string;
  connect() {
    // Fractional zoom lets fitBounds fill the view instead of dropping to the
    // next whole level out; the +/- buttons still step by a full level.
    this.map = L.map(this.element, { zoomSnap: 0.25 });

    L.tileLayer(
      `https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=${this.apiKeyValue}`,
      {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: "abcd",
        maxZoom: 20,
      }
    ).addTo(this.map);

    if (this.locationsValue?.length > 0) {
      const points = this.locationsValue.map((loc) => [loc.lat, loc.lon]);
      const bounds = L.latLngBounds(points as L.LatLngTuple[]);

      this.locationsValue.forEach((loc) => {
        const isSpecial = !!loc.marker;

        const marker = L.marker([loc.lat, loc.lon], {
          icon: isSpecial ? specialIcon : defaultIcon,
          zIndexOffset: isSpecial ? 1000 : 0,
        }).addTo(this.map);

        if (loc.address) {
          marker.bindPopup(`<b>${loc.name}</b>`);
        }

        if (isSpecial && loc.radius) {
          // Show the searched radius and make sure the whole area is in view.
          L.circle([loc.lat, loc.lon], {
            radius: loc.radius,
            color: "#16a34a",
            weight: 1,
            fillOpacity: 0.08,
            interactive: false,
          }).addTo(this.map);
          // circle.getBounds() needs the map to have a view already, which it doesn't until
          // fitBounds below, so work the area out from the centre and radius instead.
          bounds.extend(L.latLng(loc.lat, loc.lon).toBounds(loc.radius * 2));
        }
      });

      // Fit both the search area and every result; cap the zoom so a lone
      // pin with no radius does not zoom in to street level.
      this.map.fitBounds(bounds, { padding: [24, 24], maxZoom: 14 });
    } else {
      this.map.setView([-37.8136, 144.9631], 12);
      this.map.setZoom(this.map.getZoom() + 1);
    }
  }
}
